import { Col, Row } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import cl from '../catalog.module.css';

const CardItem = ({ item, close, active }) => {
    const navigate = useNavigate();
    return (
        <Col
            xs={12}
            sm={10}
            md={8}
            lg={4}
            className={cl.imageContainer}
            onClick={() => {
                if (active !== 'partner') {
                    navigate(`/publication/${active}/${item.id}`);
                    close(false);
                }
            }}
        >
            <img className={cl.imageCard} src={item.previewImage} alt="" />

            <Row justify="center" className={cl.item}>
                <div className={cl.link}>{item.title}</div>
            </Row>
        </Col>
    );
};
export default CardItem;
